if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"shellApp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(3556|3945|4492|8393)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}